<template>
  <el-drawer v-model="visible" :size="400" append-to-body destroy-on-close class="history-drawer" :z-index="2100">
    <template #header>
      <div>
        <div class="history-drawer__title">Conversation history</div>
        <div class="history-drawer__subtitle">
          {{ conversation.member?.full_name ?? "Patient" }} · {{ conversation.subject }}
        </div>
      </div>
    </template>

    <p v-if="!entries.length" class="history-drawer__empty">No history recorded yet.</p>
    <el-timeline v-else>
      <el-timeline-item
        v-for="entry in entries"
        :key="entry.key"
        :color="entry.kind === 'change' ? CHANGE_COLOR : BOOKEND_COLOR"
        hide-timestamp
      >
        <div class="history-drawer__entry">{{ entry.title }}</div>
        <div class="history-drawer__detail"><i class="fa-regular fa-user" /> {{ entry.detail }}</div>
        <div class="history-drawer__detail"><i class="fa-regular fa-clock" /> {{ formatMessageTime(entry.at) }}</div>
      </el-timeline-item>
    </el-timeline>
  </el-drawer>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { PatientConversationDTO } from "@vitable/asclepius-api-client-ts"
import { formatMessageTime } from "@/modules/patient-conversations/utils/patient-conversation-format"
import {
  buildConversationHistory,
  ConversationHistoryEntry
} from "@/modules/patient-conversations/utils/patient-conversation-history"

const props = defineProps<{
  conversation: PatientConversationDTO
}>()

const visible = defineModel<boolean>({ required: true })

// Brand palette ($primary / $empty-text); el-timeline-item takes the colour as a prop
const CHANGE_COLOR = "#56B7A9"
const BOOKEND_COLOR = "#333333"

const entries = computed<Array<ConversationHistoryEntry>>(() => buildConversationHistory(props.conversation))
</script>

<style scoped lang="sass">
@import "@/styles/colors"

.history-drawer
  &__title
    font-size: 16px
    font-weight: 700
    color: $empty-text

  &__subtitle
    margin-top: 2px
    font-size: 13px
    color: $grey

  &__entry
    font-size: 14px
    font-weight: 600
    color: $empty-text

  &__detail
    display: flex
    align-items: center
    gap: 6px
    margin-top: 2px
    font-size: 13px
    color: $grey

    i
      width: 14px
      text-align: center
      font-size: 12px

  &__empty
    font-size: 13px
    color: $grey
</style>
